import { SET_USER_CALENDAR_SETTINGS, GET_USER_CALENDAR_SETTINGS } from "../../actions/Calendar/saveCalendarSettingsAction";

const initialState = {
    defaultView: "Week",
    timeFormat: "TwelveHour",
    eventDuration: 'Minutes15',
    weekDayStartOn: 1,
    showWeekends: true,
    colors: {
        globalTasks: '#D5D6FF',
        primary: '#E5F6D1',
        timetable: '#BBE7FC'
    }
};

const setCalendarUserSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_CALENDAR_SETTINGS:
            console.log("Calling setCalendarUserSettingsReducer");
            console.log(action.payload);
            if (action.payload) {
                return {
                    ...state,
                    ...action.payload,                    
                    colors: {
                        ...state.colors,
                        ...(action.payload.colors || {})
                    }
                };
            }
            return state;
        case GET_USER_CALENDAR_SETTINGS:
            // Handle loading state if needed
            return state;
        default:
            return state;
    }
};

export default setCalendarUserSettingsReducer;